import cx from "classnames";
import { useAtom } from "jotai";
import React, { memo, useEffect, useRef, useState } from "react";
import { message } from "antd";
import { fetchGetCarFilterData } from "@Services/article";
import RadioOrCheckbox from "./RadioOrCheckbox";
import { IListData } from "../CarBrands/List";

import styles from "./ModelsFilter.module.less";
import icon from "../../../../../public/assets/static/models/icon-right.png";
import iconWhite from "../../../../../public/assets/static/models/icon-white.png";

import blueBg from "../../../../../public/assets/static/models/filter-bg.png";
import greenBg from "../../../../../public/assets/static/models/filter-bg-green.png";

import bluePopupBg from "../../../../../public/assets/static/models/search-bg.png";
import greenPopupBg from "../../../../../public/assets/static/models/search-bg-green.png";
import { initTracking } from "@Lib/jotai/tracking";
import AdBySelfRefresh from "@Components/ad/AdBySelfRefresh";

import { Common } from "@Api";

const { postInitialCollect } = Common;

interface IProps {
  themeColorStyle?: {
    color: string;
    background: string;
  };
  brandsListItem?: IListData[];
  onChange?: (e: any) => any;
}

interface IFilter {
  brands: IFilterBrands;
  params: Array<IFilterParamsAndOther>;
  otherParams: Array<IFilterParamsAndOther>;
}

interface IFilterBrands {
  label: string;
  field: string;
  option: any;
}
interface IFilterParamsAndOther {
  label: string;
  field: string;
  key: string;
  selectType: string;
  option: Array<{
    name: string;
    value: string;
  }>;
}

export enum EFilterType {
  Price = "price",
  Kinds = "autoType",
  Fuel = "power",
}

const Filter = React.memo((props: IProps) => {
  const { themeColorStyle, brandsListItem, onChange } = props;
  const [dataSource, setDataSource] = useState<IFilter>();
  const [brandsKey, setBrandsKey] = useState<string>("hot");
  const [brandsImgKey, setBrandsImgKey] = useState<number | null>(null);
  const [brandsImgList, setBrandsImgList] = useState<any>([]);
  const [paramsKey, setParamsKey] = useState<object>({});
  const [otherKey, setOtherKey] = useState<string | null>(null);
  const [otherModelsKey, setModelsOtherKey] = useState<string | null>(null);
  const [filterItem, setFilterItem] = useState<any[]>([]);
  const [customPriceBtn, setCustomPriceBtn] = useState<boolean>(false);
  const [popupBtnShow, setPopupBtnShow] = useState<boolean>(false);
  const [popupBtnListData, setPopupBtnListData] = useState<IFilterParamsAndOther[]>([]);
  const [radioAcitveKey, setRdioAcitveKey] = useState<any>();
  const [checkboxSelectedList, setCheckboxSelectedList] = useState<any[]>([]);
  const [brandsListData, setBrandsListData] = useState<IListData[]>([]);
  const [tracking] = useAtom(initTracking);

  const filterData = useRef({});
  const minPrice = useRef<number | null>(null);
  const maxPrice = useRef<number | null>(null);
  const minValueRef = useRef(null);
  const maxValueRef = useRef(null);

  useEffect(() => {
    if (!window.SEARCH_TYPE) return;
    handleClickEmpty();
    fetchSelect();

    tracking && tracking.trackEvent({
      name: "element_exposured",
      params: {
        "page_sub_business": "新車資料庫",
        "page_business": "新車",
        "trigger_id": "4045",
        "page_id": "73",
        "trigger_name": "找車頁篩選條件",
        "next_spm": "3.73.766.2138",
        "page": "找車頻道頁",
        "channel": "新車",
        "element_id": "找車頁篩選條件",
        "element": "按鈕",
        "module": "新車篩選條件",
        "tracker_method": "config"
      }
    });

  }, [window.SEARCH_TYPE]);

  /** 获取筛选项数据 */
  const fetchSelect = async () => {
    try {
      const res: { data, status } = await fetchGetCarFilterData({
        type: window.SEARCH_TYPE || "default", // ev为电动车，default为普通
        ads: 1,
      });
      if (res && res.status === 12000) {
        setDataSource(res.data);
        setBrandsImg(res.data.brands, "hot");
        setPopupBtnListData(
          res.data.params.filter((item) => [EFilterType.Fuel, EFilterType.Kinds, EFilterType.Price].includes(item.key)),
        );
        getBrandsList(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /** 获取所有厂牌列表 */
  const getBrandsList = async (selectData) => {
    setBrandsListData(brandsListItem!);
    setFilterPath(selectData, brandsListItem);
  };

  /** 设置厂牌icon */
  const setBrandsImg = async (data: any, value: string = "") => {
    if (value === "") {
      setBrandsImgList([]);
      return;
    }
    setBrandsImgList([...data?.option.values]);
  };

  /** 点击筛选项中数据 */
  const handleClickParams = async (params) => {
    setParamsKey({
      ...paramsKey,
      [params.key]: params.value,
    });
    handleClickfilter(params);
    if (params.key === "price") {
      setCustomPriceBtn(false);
      minValueRef.current && ((minValueRef.current as any).value = null);
      maxValueRef.current && ((maxValueRef.current as any).value = null);
    }
  };

  /** 厂牌选择 */
  const handleClickImgKey = async (item) => {
    dataSource && (filterData.current[dataSource.brands.field] = item.value);

    // const str = location.pathname.split('/').find(res => res.includes('x-'))
    // const link = `${location.origin}/Models/${item.brandUrlName}${window.SEARCH_TYPE === 'default' ? '' : '/ev'}${str ? '/search/'+str : ''}`
    // window.location.href = link
  };

  /** 其他项选择 */
  const handleClickOther = async (item, type: string = "") => {
    if (type === "close") {
      setOtherKey("");
      setModelsOtherKey(null);
    } else {
      const index = filterItem.findIndex((res) => res.key === item.field);
      if (index === -1) {
        setRdioAcitveKey(-1);
      } else {
        filterItem.find((data) => {
          if (item.field === data.key) {
            setRdioAcitveKey(data);
          }
        });
      }
      setOtherKey(item.key);
      setModelsOtherKey(item.key);
    }
  };

  /** 自定义价格 */
  const setCustomPrice = async (value: number, type: string) => {
    type === "min" && (minPrice.current = value);
    type === "max" && (maxPrice.current = value);
    if (minPrice.current && maxPrice.current) {
      setCustomPriceBtn(true);
    }
  };

  /** 自定义价格-确认 */
  const handleConfirmPrice = async (item) => {
    if (!customPriceBtn) return;
    if ((minPrice.current !== null && minPrice.current) > (maxPrice.current !== null && maxPrice.current)) {
      message.warning("最小價格不可大於最大價格");
      return;
    }
    setParamsKey({
      ...paramsKey,
      [item.key]: item.value,
    });
    handleClickfilter(item);
  };

  /** 其他筛选项 */
  const handleChangeOther = async (item) => {
    const { type, checked, fieldKey, ...restParams } = item;
    if (type === "radio") {
      handleClickfilter(restParams);
    } else {
      const index = filterItem.findIndex((res) => res.key === item.key);
      const list = filterItem || [];
      const paramsList: any[] = [];

      if (index !== -1 && !checked) {
        list.splice(index, 1);
      }
      checked && list.unshift(item);
      setFilterItem([...list]);
      list.find((r) => {
        r.checked && paramsList.push(r.value);
      });
      setCheckboxSelectedList([...paramsList]);
      filterData.current[fieldKey] = paramsList.join(",");
      handleFilterData();
    }
  };
  /** 过滤list的参数 */
  const handleFilterData = async () => {
    clickSetFilterPath();
    onChange && onChange(filterData.current);
  };

  /** 过滤val的参数 */
  const setValue = (key, value) => {
    switch (key) {
      case "price": // 价格
      case "g": // 排量
      case "batteryLife": // 续航
        return `${value.replace(/[\-]/g, ",")}`;
        break;
      case "b": // 厂牌，需要占位
        return `${"x"}`;
        break;
      default:
        return value || "x";
        break;
    }
  };

  /** 点击设置seo筛选链接参数 */
  const clickSetFilterPath = async (data = {}) => {
    const dataObj: any = dataSource ? dataSource : data;
    let path = "";
    let link = "";
    if (JSON.stringify(dataObj) !== "{}") {
      const list = [
        {
          label: dataObj?.brands.label,
          field: dataObj?.brands.field,
          key: dataObj?.brands.field,
        },
        ...dataObj?.params,
        ...dataObj?.otherParams,
      ];
      const str = location.pathname.split("/").find((res) => res.includes("x-"));
      const pathValueArr: any[] = str ? str.split("-") : [];
      list.find((item, index) => {
        pathValueArr[index] = "x";
        Object.keys(filterData.current).find((i, idx) => {
          const value: any = Object.values(filterData.current)[idx];
          if (i === item.field) {
            pathValueArr[index] = setValue(i, value);
          } else if (item.key === "safeSpec" || item.key === "conformSpec" || item.key === "otherSpec") {
            const val: string = filterData.current[item.field];
            pathValueArr[index] = !val || val === "" ? "x" : val;
          }
        });
      });
      path = pathValueArr.join("-");
      const brandStr: any = window.BRAND_INFO_DESCRIPTION?.brandUrlName ?? "";

      link = `${location.origin}/Models${brandStr ? "/" + brandStr : ""}${window.SEARCH_TYPE === "default" ? "" : "/ev"
        }/search/${path}`;

      tracking && tracking.trackEvent({
        name: "element_clicked",
        params: {
          "page_sub_business": "新車資料庫",
          "page_business": "新車",
          "trigger_id": "4046",
          "page_id": "73",
          "trigger_name": "找車頁篩選條件",
          "next_spm": "3.73.766.2138",
          "page": "找車頻道頁",
          "channel": "新車",
          "element_id": "找車頁篩選條件",
          "element": "按鈕",
          "module": "新車篩選條件",
          "tracker_method": "config",
          expand: path || '',
        }
      });

      str ? history.replaceState(null, "", link) : (window.location.href = link);
    }
  };

  /** 设置seo筛选链接参数 */
  const setFilterPath = async (data = {}, brandsList) => {
    const dataObj: any = dataSource ? dataSource : data;
    const pathValueArr: any[] = [];
    let paramsCheckboxList: any[] = [];
    const pathParams = window.SEARCH ? window.SEARCH.search_params : {};
    const obj = {};
    if (dataObj?.otherParams.length || dataObj?.params.length) {
      const list = [
        {
          label: dataObj?.brands.label,
          field: dataObj?.brands.field,
          key: dataObj?.brands.field,
        },
        ...dataObj?.params,
        ...dataObj?.otherParams,
      ];

      list.find((item, index) => {
        if (window.SEARCH && window.SEARCH.search_list === 1) {
          history.replaceState(null, "", location.href);
          Object.keys(pathParams).find((i, idx) => {
            if (i === item.key && Object.values(pathParams)[idx] !== "x") {
              const val: any = Object.values(pathParams)[idx];
              switch (item.key) {
                case "b": // 厂牌
                  const opt = brandsListData.length ? brandsListData : brandsList;
                  setBrandsImgKey(Number(val));
                  setBrandsImgList([...dataObj.brands.option.values]);
                  break;
                case "price": // 价格
                  const index = item.option.findIndex((p) => p.value === `${val.split(",")[0]}-${val.split(",")[1]}`);
                  if (index === -1) {
                    minValueRef.current && ((minValueRef.current as any).value = val.split(",")[0]);
                    maxValueRef.current && ((maxValueRef.current as any).value = val.split(",")[1]);
                    setCustomPriceBtn(true);
                    pathValueArr.push({
                      key: item.field,
                      value: `${val.split(",")[0]}-${val.split(",")[1]}`,
                      name: `${val.split(",")[0]}-${val.split(",")[1]}萬`,
                    });
                  } else {
                    pathValueArr.push({
                      key: item.field,
                      value: `${val.split(",")[0]}-${val.split(",")[1]}`,
                      name: getValueName(item.option, `${val.split(",")[0]}-${val.split(",")[1]}`),
                    });
                  }
                  obj[item.field] = `${val.split(",")[0]}-${val.split(",")[1]}`;
                  break;
                case "safeSpec":
                case "conformSpec":
                case "otherSpec":
                  obj[item.field] = val;
                  paramsCheckboxList = val.split(",");

                  val !== "" &&
                    val.split(",").find((i) => {
                      const index = pathValueArr.findIndex((res) => res.key === i);
                      if (index === -1 && getValueName(item.option, i) !== "") {
                        pathValueArr.push({
                          type: "checkbox",
                          checked: true,
                          fieldKey: item.field,
                          key: i,
                          value: i,
                          name: getValueName(item.option, i),
                        });
                      }
                    });
                  break;
                default: // 油车-排量、电车-续航
                  const v =
                    item.field === "g" || item.field === "batteryLife"
                      ? `${val.split(",")[0]}-${val.split(",")[1]}`
                      : val;
                  obj[item.field] = v;
                  pathValueArr.push({
                    key: item.field,
                    value: v,
                    name: getValueName(item.option, v),
                  });
                  break;
              }
            }
          });
        }
      });
      /**判断路由只有厂牌但是没有x的 */
      if (window.BRAND_INFO_DESCRIPTION) {
        setBrandsImgKey(Number(window.BRAND_INFO_DESCRIPTION.brandId));
        pathValueArr.push({
          key: dataObj.brands.field,
          value: window.BRAND_INFO_DESCRIPTION.brandId,
          name: window.BRAND_INFO_DESCRIPTION.brandName,
        });
        obj[dataObj.brands.field] = window.BRAND_INFO_DESCRIPTION.brandId;
      }
      setParamsKey(obj);
      setCheckboxSelectedList([...paramsCheckboxList]);
      setFilterItem(pathValueArr);
      filterData.current = obj;
      onChange && onChange(filterData.current);
    }
  };

  /** 獲取數據名稱 */
  const getValueName = (list, key) => {
    const n = list.length && list.filter((r) => r.value == key);
    const name = n.length ? n[0].name : "";
    return name;
  };

  /** 展开收起 */
  const handleCloseShowPopup = async () => {
    setPopupBtnShow(!popupBtnShow);
    const list: any = dataSource?.params.filter((item: any) =>
      [EFilterType.Fuel, EFilterType.Kinds, EFilterType.Price].includes(item.key),
    );
    popupBtnShow ? setPopupBtnListData([...list]) : dataSource && setPopupBtnListData([...dataSource.params]);
  };

  /** 重置 */
  const handleClickEmpty = async () => {
    // 厂牌
    const imgBrandsList: any = dataSource ? dataSource?.brands?.option.values.filter((item) => item.key === "hot") : [];
    setBrandsKey("hot");
    imgBrandsList.length && setBrandsImgList([...imgBrandsList[0].values]);
    setBrandsImgKey(null);
    // 中部
    setParamsKey({});
    setCustomPriceBtn(false);
    minValueRef.current && ((minValueRef.current as any).value = null);
    maxValueRef.current && ((maxValueRef.current as any).value = null);

    setCheckboxSelectedList([]);
    setFilterItem([]);
    filterData.current = {};
  };

  /** 重置-提交 */
  const handleClickEmptyValue = async () => {
    const link = `${location.origin}/Models${window.SEARCH_TYPE === "default" ? "" : "/ev"}`;
    window.location.href = link;
  };

  /** 已选项 */
  const handleClickfilter = async (params: any) => {
    filterData.current = {};
    const index = filterItem.findIndex((item) => item.key === params.key);
    const list: any = filterItem || [];
    const paramsList: any[] = [];

    if (index !== -1) {
      list.splice(index, 1);
    }
    if (params.hasOwnProperty("value")) {
      list.unshift(params);
    }
    setFilterItem([...list]);
    list.find((item) => {
      item.type && item.type === "checkbox" ? paramsList.push(item.value) : (filterData.current[item.key] = item.value);
      paramsList.length && (filterData.current[item.fieldKey] = paramsList.join(","));
    });

    handleFilterData();
  };

  /** 删除已选项 */
  const handleClickClose = async (res) => {
    const index = filterItem.findIndex((item) => item.key === res.key);
    const list: any = filterItem;
    list.splice(index, 1);
    setFilterItem([...list]);
    res.key === dataSource?.brands.field && setBrandsImgKey(null);
    setParamsKey({
      ...paramsKey,
      [res.key]: "",
    });
    if (res.key === "price") {
      setCustomPriceBtn(false);
      minValueRef.current && ((minValueRef.current as any).value = null);
      maxValueRef.current && ((maxValueRef.current as any).value = null);
    }
    delete filterData.current[res.key];
    if (res.fieldKey === "cf") {
      const arr = filterData.current[res.fieldKey].split(",");
      const index = arr.findIndex((i) => i === res.key);
      if (index > -1) {
        arr.splice(index, 1);
      }
      setCheckboxSelectedList([...arr]);
      arr.length === 0 ? delete filterData.current[res.fieldKey] : (filterData.current[res.fieldKey] = arr.join(","));
    }
    if (res.key === "b") {
      const str = location.pathname.split("/").find((res) => res.includes("x-"));
      const link = `${location.origin}/Models${window.SEARCH_TYPE === "default" ? "" : "/ev"}${str ? "/search/" + str : ""
        }`;
      window.location.href = link;
      return;
    }
    if (JSON.stringify(filterData.current) === "{}") {
      handleClickEmptyValue();
      return;
    }

    const brandUrlName = window.BRAND_INFO_DESCRIPTION?.brandUrlName ?? "";
    const searchType = window.SEARCH_TYPE === "default" ? "" : "/ev";
    const link = `${location.origin}/Models/${brandUrlName}${searchType}`;

    Object.keys(filterData.current).length >= 1 ? handleFilterData() : (window.location.href = link);
  };

  const str = location.pathname.split("/").find((res) => res.includes("x-"));

  return (
    <>
      <div
        className={styles["select"]}
        style={{
          backgroundImage: `url(${window.SEARCH_TYPE ? (window.SEARCH_TYPE === "default" ? blueBg : greenBg) : ""})`,
          border: `1px solid ${themeColorStyle && themeColorStyle.background}`,
          minHeight: "262px",
        }}
      >
        {otherModelsKey !== null && (
          <div className={styles["mask"]} onClick={() => handleClickOther("", "close")}></div>
        )}
        <div className={styles["brands-box"]}>
          {brandsImgList.length > 0 &&
            brandsImgList?.map((item) => {
              const isAd = item.ads && item.ads.adclick !== "";
              const baseUrl = `${location.origin}/Models/${item?.brandUrlName}`;
              const searchTypePath = window.SEARCH_TYPE === "default" ? "" : "/ev";
              const searchPath = str ? `/search/${str}` : "";
              const fallbackUrl = `${baseUrl}${searchTypePath}${searchPath}`;

              const href = isAd ? item.ads.adclick : fallbackUrl;
              return (
                <div className={styles["brands-item"]} key={item.value}>
                  {item.ads && (
                    <AdBySelfRefresh
                      data={item.ads}
                      first={true}
                      refresh={() => postInitialCollect(item.ads, "show", "")}
                      styles={{ display: "inline-block" }}
                    />
                  )}
                  <a
                    className={cx(styles["item-box"])}
                    style={{
                      border:
                        brandsImgKey === item.value ? `1px solid ${themeColorStyle && themeColorStyle.background}` : "",
                    }}
                    onClick={() => {
                      item.ads && postInitialCollect(item.ads, "click");
                      handleClickImgKey(item)
                    }}
                    href={href}
                    target="_blank"
                  >
                    <img src={item.icon} className={styles["item-img"]} />
                    <div className={styles["item-name"]}>{item.name}</div>
                  </a>
                </div>
              )
            })}
        </div>
        <div className={styles["params"]}>
          {popupBtnListData.map((item, index) => (
            <div className={styles["params-item"]} key={item.field}>
              <p className={styles["models-title"]}>{item.label || ""}</p>
              <div className={styles["models-main"]}>
                <div
                  className={cx(styles["main-letter"])}
                  style={!paramsKey[item.field] ? themeColorStyle : {}}
                  onClick={() =>
                    handleClickParams({
                      key: item.field,
                    })
                  }
                >
                  不限
                </div>
                {item.option.map((res) => (
                  <div
                    key={res.value}
                    className={cx(styles["main-letter"])}
                    style={paramsKey[item.field] == res.value ? themeColorStyle : {}}
                    onClick={() =>
                      handleClickParams({
                        key: item.field,
                        value: res.value,
                        name: res.name,
                      })
                    }
                  >
                    {res.name}
                  </div>
                ))}
                {item.field === "price" && (
                  <div className={styles["price-custom"]}>
                    <div className={styles["custom-box"]}>
                      <input
                        className={styles["box-input"]}
                        type='number'
                        min={1}
                        max={10000}
                        ref={minValueRef}
                        onChange={(e) => {
                          setCustomPrice(Number(e.target.value), "min");
                          !(maxValueRef.current as any).value && setCustomPriceBtn(false);
                        }}
                      />
                      至
                      <input
                        className={styles["box-input"]}
                        type='number'
                        min={1}
                        max={10000}
                        ref={maxValueRef}
                        onChange={(e) => {
                          setCustomPrice(Number(e.target.value), "max");
                          !(minValueRef.current as any).value && setCustomPriceBtn(false);
                        }}
                      />
                      萬
                    </div>
                    <div
                      className={cx(styles["custom-btn"])}
                      style={customPriceBtn ? themeColorStyle : {}}
                      onClick={() =>
                        handleConfirmPrice({
                          key: item.field,
                          value: `${minPrice.current}-${maxPrice.current}`,
                          name: `${minPrice.current}-${maxPrice.current}萬`,
                        })
                      }
                    >
                      確認
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {popupBtnShow && (
          <div className={styles["other"]}>
            <div className={styles["other-item"]}>
              <p className={styles["models-title"]}>其他</p>
              {dataSource?.otherParams?.map((item, index) => (
                <div key={item.key} className={styles["models-main"]} onClick={() => handleClickOther(item)}>
                  <p className={cx(styles["main-letter"])} style={otherKey === item.key ? themeColorStyle : {}}>
                    {item.label}
                    <img
                      src={otherKey !== item.key ? icon : iconWhite}
                      className={cx(styles["icon"], {
                        [styles["icon-white"]]: otherKey === item.key,
                      })}
                    />
                  </p>
                  <RadioOrCheckbox
                    themeColorStyle={themeColorStyle}
                    radioAcitve={radioAcitveKey}
                    type={item.selectType}
                    data={item.option}
                    visible={otherModelsKey === item.key}
                    fieldKey={item.field}
                    checkboxFieldKeyList={checkboxSelectedList}
                    onChange={(e) => handleChangeOther(e)}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {filterItem.length > 0 && (
          <div className={styles["options"]}>
            <p className={styles["models-title"]}>已選</p>
            <div className={styles["options-list"]}>
              {filterItem?.map((item, index) => (
                <p
                  className={styles["list-item"]}
                  key={index}
                  onClick={() => handleClickClose(item)}
                  style={{
                    background: themeColorStyle && themeColorStyle.background,
                    opacity: 0.6,
                  }}
                >
                  {item.name}
                  <span className={styles["close"]}></span>
                </p>
              ))}
            </div>
            {filterItem.length > 0 && (
              <p className={styles["models-text"]} onClick={() => handleClickEmptyValue()} style={themeColorStyle}>
                重置
              </p>
            )}
          </div>
        )}
      </div>
      <div
        className={styles["popup-btn"]}
        onClick={handleCloseShowPopup}
        style={{
          backgroundImage: `url(${window.SEARCH_TYPE ? (window.SEARCH_TYPE === "default" ? bluePopupBg : greenPopupBg) : ""
            })`,
        }}
      >
        <div className={styles["popup-box"]}>
          {popupBtnShow ? "收起" : "更多篩選條件（排量/配備）"}
          <img
            src={icon}
            className={cx({
              [styles["bottom-icon"]]: !popupBtnShow,
              [styles["top-icon"]]: popupBtnShow,
            })}
          />
        </div>
      </div>
    </>
  );
});

export default memo(Filter);
